module.exports = __webpack_public_path__ + "img/selfAdhesive2.e9a373ac.jpg";